export default function Privacy() {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 px-6 py-16 pt-24">
      <div className="max-w-4xl mx-auto bg-white border border-slate-200 rounded-2xl p-8 shadow-sm space-y-6">
        <div>
          <h1 className="text-3xl font-bold">Política de Privacidad</h1>
          <p className="text-sm text-slate-500 mt-2">Última actualización: 18 de octubre de 2026</p>
        </div>

        <section className="space-y-2">
          <h2 className="text-xl font-semibold">1. Responsable del tratamiento</h2>
          <p className="text-slate-700">
            Reclamos Financieros Argentina (RFA) es responsable del tratamiento de los datos personales utilizados para prestar sus servicios y operar su plataforma.
          </p>
          <p className="text-slate-700">
            Para consultas relacionadas con privacidad o tratamiento de datos personales:
          </p>
          <p className="text-slate-700">
            <a className="text-emerald-700 font-medium" href="mailto:soporte@rfargentina.com">soporte@rfargentina.com</a>
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-xl font-semibold">2. Datos que podemos tratar</h2>
          <p className="text-slate-700">Según la forma en que el usuario utilice RFA, podemos tratar datos como:</p>
          <ul className="list-disc pl-6 space-y-1 text-slate-700">
            <li>nombre y apellido;</li>
            <li>correo electrónico;</li>
            <li>teléfono;</li>
            <li>información de contacto;</li>
            <li>empresa o proveedor involucrado;</li>
            <li>descripción del reclamo;</li>
            <li>información económica relacionada con el caso cuando resulte necesaria;</li>
            <li>modalidad de servicio;</li>
            <li>información comercial asociada al servicio contratado;</li>
            <li>archivos adjuntos;</li>
            <li>comprobantes;</li>
            <li>comunicaciones;</li>
            <li>números de gestión;</li>
            <li>código o identificador del caso;</li>
            <li>información necesaria para mantener la trazabilidad;</li>
            <li>datos técnicos y registros de seguridad necesarios para operar y proteger la plataforma.</li>
          </ul>
          <p className="text-slate-700">
            La documentación aportada por el usuario puede contener datos personales adicionales necesarios para analizar o gestionar el reclamo.
          </p>
          <p className="text-slate-700">En consultas o cuentas de RFA Empresas también podemos tratar:</p>
          <ul className="list-disc pl-6 space-y-1 text-slate-700">
            <li>nombre de la empresa;</li>
            <li>rubro;</li>
            <li>nombre y datos del contacto;</li>
            <li>cargo o función;</li>
            <li>volumen estimado de casos;</li>
            <li>información relacionada con la necesidad operativa informada.</li>
          </ul>
        </section>

        <section className="space-y-2">
          <h2 className="text-xl font-semibold">3. Finalidades del tratamiento</h2>
          <p className="text-slate-700">Los datos pueden utilizarse para:</p>
          <ul className="list-disc pl-6 space-y-1 text-slate-700">
            <li>recibir casos;</li>
            <li>realizar el análisis inicial;</li>
            <li>organizar antecedentes y documentación;</li>
            <li>reconstruir cronologías;</li>
            <li>identificar documentación faltante;</li>
            <li>estructurar el reclamo;</li>
            <li>generar y administrar identificadores de casos;</li>
            <li>preparar comunicaciones;</li>
            <li>realizar las gestiones administrativas autorizadas;</li>
            <li>registrar comunicaciones y avances;</li>
            <li>prestar los servicios contratados;</li>
            <li>gestionar pagos y comprobantes cuando corresponda;</li>
            <li>responder consultas;</li>
            <li>gestionar accesos a RFA Empresas;</li>
            <li>mantener la trazabilidad de las operaciones;</li>
            <li>prevenir usos abusivos o accesos no autorizados;</li>
            <li>mantener la seguridad y funcionamiento de la plataforma.</li>
          </ul>
          <p className="text-slate-700">
            Los datos no deben utilizarse para finalidades incompatibles con aquellas para las que fueron recopilados.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-xl font-semibold">4. Datos necesarios para gestionar un caso</h2>
          <p className="text-slate-700">
            RFA procura solicitar únicamente la información razonablemente necesaria para analizar y gestionar cada caso.
          </p>
          <p className="text-slate-700">
            El usuario no debe aportar datos personales de terceros que no resulten necesarios para el reclamo.
          </p>
          <p className="text-slate-700">
            Cuando un documento contenga información adicional, RFA podrá tratarla en la medida necesaria para organizar o gestionar el caso correspondiente.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-xl font-semibold">5. Fundamento del tratamiento</h2>
          <p className="text-slate-700">El tratamiento de datos puede basarse, según corresponda, en:</p>
          <ul className="list-disc pl-6 space-y-1 text-slate-700">
            <li>el consentimiento del usuario;</li>
            <li>la solicitud de análisis o servicio realizada por el propio usuario;</li>
            <li>la ejecución de la relación de servicio;</li>
            <li>autorizaciones específicas otorgadas para determinadas gestiones;</li>
            <li>obligaciones aplicables;</li>
            <li>necesidades razonables de seguridad y funcionamiento de la plataforma.</li>
          </ul>
          <p className="text-slate-700">
            Las autorizaciones opcionales para realizar comunicaciones administrativas se gestionan separadamente cuando corresponda.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-xl font-semibold">6. Conservación de la información</h2>
          <p className="text-slate-700">RFA procura conservar la información únicamente durante el tiempo necesario para:</p>
          <ul className="list-disc pl-6 space-y-1 text-slate-700">
            <li>prestar el servicio;</li>
            <li>mantener la trazabilidad correspondiente;</li>
            <li>atender consultas relacionadas con el caso;</li>
            <li>cumplir obligaciones aplicables;</li>
            <li>proteger la seguridad e integridad de la plataforma.</li>
          </ul>
          <p className="text-slate-700">
            Una vez que la información deja de ser necesaria, podrá ser eliminada o sometida a los procesos de depuración correspondientes.
          </p>
          <p className="text-slate-700">
            En cuentas de RFA Empresas pueden existir criterios específicos de conservación según la configuración y las condiciones del servicio contratado.
          </p>
          <p className="text-slate-700">
            Las copias de seguridad pueden conservar información durante períodos adicionales derivados de sus ciclos técnicos de rotación y posteriormente ser reemplazadas o eliminadas.
          </p>
          <p className="text-slate-700">
            RFA no debe interpretar esta disposición como autorización para conservar información indefinidamente.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-xl font-semibold">7. Proveedores y destinatarios</h2>
          <p className="text-slate-700">
            Para operar la plataforma, RFA puede utilizar proveedores tecnológicos necesarios para funciones como:
          </p>
          <ul className="list-disc pl-6 space-y-1 text-slate-700">
            <li>alojamiento;</li>
            <li>almacenamiento;</li>
            <li>infraestructura;</li>
            <li>base de datos;</li>
            <li>comunicaciones;</li>
            <li>correo electrónico;</li>
            <li>seguridad;</li>
            <li>soporte técnico.</li>
          </ul>
          <p className="text-slate-700">
            Estos proveedores podrán tratar únicamente la información necesaria para prestar los servicios técnicos correspondientes, sujeto a las condiciones y medidas aplicables.
          </p>
          <p className="text-slate-700">RFA no comercializa bases de datos personales de sus usuarios.</p>
          <p className="text-slate-700">
            Cuando resulte necesario comunicar información a una empresa o proveedor involucrado en un reclamo, dicha comunicación se realizará dentro del alcance del servicio y de las autorizaciones correspondientes.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-xl font-semibold">8. Transferencias y servicios tecnológicos</h2>
          <p className="text-slate-700">
            Algunos proveedores tecnológicos utilizados para operar servicios digitales pueden procesar o almacenar información utilizando infraestructura ubicada fuera de la República Argentina.
          </p>
          <p className="text-slate-700">
            Cuando corresponda, RFA procurará utilizar proveedores y mecanismos compatibles con las obligaciones aplicables en materia de protección de datos.
          </p>
          <p className="text-slate-700">
            La infraestructura y los proveedores utilizados pueden modificarse como consecuencia de cambios técnicos u operativos.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-xl font-semibold">9. Seguridad</h2>
          <p className="text-slate-700">RFA aplica medidas técnicas y organizativas razonables destinadas a reducir riesgos de:</p>
          <ul className="list-disc pl-6 space-y-1 text-slate-700">
            <li>acceso no autorizado;</li>
            <li>modificación indebida;</li>
            <li>divulgación;</li>
            <li>pérdida;</li>
            <li>uso abusivo de información.</li>
          </ul>
          <p className="text-slate-700">Entre las medidas implementadas pueden existir:</p>
          <ul className="list-disc pl-6 space-y-1 text-slate-700">
            <li>controles de acceso;</li>
            <li>permisos según usuario y caso;</li>
            <li>validación de entradas;</li>
            <li>límites de carga de archivos;</li>
            <li>controles sobre archivos;</li>
            <li>registros de eventos;</li>
            <li>mecanismos de autenticación;</li>
            <li>copias de seguridad;</li>
            <li>medidas de protección de infraestructura.</li>
          </ul>
          <p className="text-slate-700">Ningún sistema conectado a Internet puede garantizar seguridad absoluta.</p>
        </section>

        <section className="space-y-2">
          <h2 className="text-xl font-semibold">10. Acceso interno</h2>
          <p className="text-slate-700">El acceso a información almacenada en RFA debe limitarse a quienes necesiten utilizarla para:</p>
          <ul className="list-disc pl-6 space-y-1 text-slate-700">
            <li>prestar el servicio;</li>
            <li>administrar la plataforma;</li>
            <li>atender al usuario;</li>
            <li>realizar tareas operativas autorizadas;</li>
            <li>mantener la seguridad.</li>
          </ul>
          <p className="text-slate-700">
            Los usuarios de RFA Empresas únicamente deben acceder a la información correspondiente a su propia organización y a los casos habilitados para ella.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-xl font-semibold">11. Datos cargados por empresas</h2>
          <p className="text-slate-700">
            Las cuentas de RFA Empresas pueden incorporar información vinculada con casos administrados por la organización cliente.
          </p>
          <p className="text-slate-700">
            Cada empresa es responsable de contar con una base adecuada para recopilar y compartir con RFA la información necesaria para utilizar el servicio.
          </p>
          <p className="text-slate-700">
            Las responsabilidades específicas de RFA y de la empresa cliente pueden complementarse mediante las condiciones comerciales o contractuales correspondientes.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-xl font-semibold">12. Derechos de los titulares</h2>
          <p className="text-slate-700">Los titulares de datos personales pueden solicitar, según corresponda conforme a la normativa aplicable:</p>
          <ul className="list-disc pl-6 space-y-1 text-slate-700">
            <li>acceso;</li>
            <li>actualización;</li>
            <li>rectificación;</li>
            <li>supresión.</li>
          </ul>
          <p className="text-slate-700">Las solicitudes pueden enviarse a:</p>
          <p className="text-slate-700">
            <a className="text-emerald-700 font-medium" href="mailto:soporte@rfargentina.com">soporte@rfargentina.com</a>
          </p>
          <p className="text-slate-700">
            RFA podrá solicitar información razonablemente necesaria para verificar la identidad del solicitante antes de entregar, modificar o eliminar información.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-xl font-semibold">13. Comunicaciones administrativas</h2>
          <p className="text-slate-700">
            La aceptación de esta Política de Privacidad no implica automáticamente que el usuario autorice a RFA a enviar comunicaciones administrativas en su nombre.
          </p>
          <p className="text-slate-700">
            Cuando el servicio contratado requiera una autorización específica para realizar comunicaciones relacionadas con un reclamo, dicha autorización se solicitará separadamente cuando corresponda.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-xl font-semibold">14. Menores de edad</h2>
          <p className="text-slate-700">
            Los servicios de RFA están orientados a personas con capacidad suficiente para contratar y gestionar los reclamos correspondientes.
          </p>
          <p className="text-slate-700">
            Si RFA detecta que se proporcionó información de un menor sin una base adecuada para su tratamiento, podrá solicitar aclaraciones o adoptar las medidas necesarias respecto de esa información.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-xl font-semibold">15. Cambios en la Política de Privacidad</h2>
          <p className="text-slate-700">RFA podrá actualizar esta Política para reflejar:</p>
          <ul className="list-disc pl-6 space-y-1 text-slate-700">
            <li>cambios normativos;</li>
            <li>modificaciones operativas;</li>
            <li>cambios tecnológicos;</li>
            <li>nuevas medidas de seguridad;</li>
            <li>modificaciones en los servicios.</li>
          </ul>
          <p className="text-slate-700">
            La versión vigente será la publicada en el sitio, identificada mediante su fecha de última actualización.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-xl font-semibold">16. Contacto</h2>
          <p className="text-slate-700">
            Para consultas sobre privacidad, tratamiento de información o ejercicio de derechos:
          </p>
          <p className="text-slate-700">
            <a className="text-emerald-700 font-medium" href="mailto:soporte@rfargentina.com">soporte@rfargentina.com</a>
          </p>
        </section>
      </div>
    </div>
  );
}
